var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"VueTables__primary-content"},[_vm._v(_vm._s(_vm.data.client_name))]),_vm._v(" "),(_vm.prefixedName)?_c('div',{staticClass:"VueTables__secondary-content"},[_vm._v(_vm._s(_vm.prefixedName))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }